import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/style/common.css";
import "animate.css";
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(ElementUI, { size: "small", zIndex: 3000 }); // 项目中所有拥有 size 属性的组件的默认尺寸均为 'small'，弹框的初始 z-index 为 3000
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
